/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.PublishStatus_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.PublishStatus domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum PublishStatus_ {
   /// <summary>
   ///   Draft (DR)
   /// </summary>
   Draft = 1,
   /// <summary>
   ///   Pending Moderation (PM)
   /// </summary>
   Pending = 2,
   /// <summary>
   ///   Published/Live (PB)
   /// </summary>
   Published = 3,
   /// <summary>
   ///   Trashed (TR)
   /// </summary>
   Trashed = 4,
   /// <summary>
   ///   Archived (AR)
   /// </summary>
   Archived = 5
}

export const PublishStatuses: PublishStatus[] = [
   {
      code: PublishStatus_.Draft,
      literal: 'Draft',
      description: 'Draft',
      shortDescription: 'DR',
      listPriority: 0,

      typeName: "PublishStatus"
   },
   {
      code: PublishStatus_.Pending,
      literal: 'Pending',
      description: 'Pending Moderation',
      shortDescription: 'PM',
      listPriority: 0,

      typeName: "PublishStatus"
   },
   {
      code: PublishStatus_.Published,
      literal: 'Published',
      description: 'Published/Live',
      shortDescription: 'PB',
      listPriority: 0,

      typeName: "PublishStatus"
   },
   {
      code: PublishStatus_.Trashed,
      literal: 'Trashed',
      description: 'Trashed',
      shortDescription: 'TR',
      listPriority: 0,

      typeName: "PublishStatus"
   },
   {
      code: PublishStatus_.Archived,
      literal: 'Archived',
      description: 'Archived',
      shortDescription: 'AR',
      listPriority: 0,

      typeName: "PublishStatus"
   }
]

export class PublishStatus implements IDomainModel {
   code: PublishStatus_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: PublishStatus_): PublishStatus {
      return PublishStatuses.find(d => d.code === code)
   }
}
